'use client';

import { FC } from 'react';
import { LandingIconsListStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import { Image } from 'atoms/Image/Image';
import { RichTextMarkdown } from 'pages/StoryBlok/RichText';
import styles from './styles.module.css';

export const LandingIconsList: FC<{ blok: LandingIconsListStoryblok }> = ({
  blok,
}) => {
  return (
    <div className={styles.root}>
      <Container className={styles.container}>
        {blok.icons?.map((item) => (
          <div key={item._uid} className={styles.icon}>
            <Image
              className={styles.image}
              src={item.icon?.filename}
              alt={item.icon?.alt}
            />
            {item.name && (
              <RichTextMarkdown text={item.name} className={styles.text} />
            )}
          </div>
        ))}
      </Container>
    </div>
  );
};
